module.exports = __webpack_public_path__ + "static/media/check_red.78da0552.svg";